
import {Component, Prop, Vue} from 'vue-property-decorator';
import stores from '@/stores';
import {SweetModal} from 'sweet-modal-vue';
import GlobalFunctions from '@/GlobalFunctions';

@Component({
  components: {
    SweetModal,
  },
})
export default class CreateTypes extends Vue {

  types: any = {
    name : '',
  };
  firstNameRules = {};
  lastNameRules = {};
  companyRules = {};

  globalFunctions = new GlobalFunctions();

  onSubmit() {
    return stores.Stays.createNewTypes(this.types)
      .then((response) => {
        console.log('res', response);
        this.$emit('created', response.data.id);
        this.cancel();
      })
      .catch((e) => {
        console.log(e);
      });
  }

  cancel() {
    // @ts-ignore
    this.$children[0].close();
  }
}
